
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"32","cy":"32","r":"6"}}),_c('path',{attrs:{"d":"M9 51h16v4H9z"}}),_c('path',{attrs:{"d":"M9 39h4v16H9z"}}),_c('path',{attrs:{"d":"M11.354 49.581l12.728-12.727 2.828 2.828L14.182 52.41zM39 9h16v4H39z"}}),_c('path',{attrs:{"d":"M51 9h4v16h-4z"}}),_c('path',{attrs:{"d":"M37 23.728L49.728 11l2.828 2.828-12.728 12.728z"}})])])
          )
        }
      }
    